module.exports = __webpack_public_path__ + "static/media/oconnorsuttoncronin.0f7ae0cc.png";